import request from '../utils/request'

/**
 * 创建审批流配置
 */
export function createApprovalFlowConfig(data) {
  return request({
    url: '/admin/approval-flow-config',
    method: 'post',
    data
  })
}

/**
 * 更新审批流配置
 */
export function updateApprovalFlowConfig(data) {
  return request({
    url: '/admin/approval-flow-config',
    method: 'put',
    data
  })
}

/**
 * 删除审批流配置
 */
export function deleteApprovalFlowConfig(id) {
  return request({
    url: `/admin/approval-flow-config/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取审批流配置详情
 */
export function getApprovalFlowConfigById(id) {
  return request({
    url: `/admin/approval-flow-config/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询审批流配置列表
 */
export function getApprovalFlowConfigList(params) {
  return request({
    url: '/admin/approval-flow-config/list',
    method: 'get',
    params
  })
}

/**
 * 根据企业和流程类型获取审批流配置
 */
export function getApprovalFlowConfigByCompanyAndProcess(companyId, processType) {
  return request({
    url: '/admin/approval-flow-config/by-company-process',
    method: 'get',
    params: {
      companyId,
      processType
    }
  })
}

